import ButtonGroup, { ButtonOption } from "@amzn/meridian/button-group";
import { getLocalizedDayOfWeek } from "../util/DateTimeUtil";
import React from "react";

export const WeekdaySelector = ({ value, onChange, disabledOptions }) => {
  return (
    <ButtonGroup
      value={value}
      onChange={(value) => {
        if (onChange) {
          onChange(value);
        }
      }}
    >
      {[...Array(7).keys()].map((index) => {
        const isDisabled = disabledOptions && disabledOptions.includes(index);
        return (
          <ButtonOption
            value={index}
            key={`weekday-picker-${index}`}
            disabled={isDisabled}
          >
            {getLocalizedDayOfWeek(index, "narrow")}
          </ButtonOption>
        );
      })}
    </ButtonGroup>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/WeekdaySelector.js